export const WHATSAPP_NUMBER = "919977025558";
export const WHATSAPP_DISPLAY = "+91 99770 25558";
export const OWNER_EMAIL = "brarrajdeep369@gmail.com";
export const GOOGLE_CALENDAR_URL = "https://calendar.app.google/KwrixFam1WtowYL87";

export const PACKAGES = [
  { id: "session_60", label: "Private 1:1 Session", note: "60 minutes", price: "₹2,100" },
  { id: "arc_3", label: "Recommended Arc — 3 Sessions", note: "Where the shift usually lands", price: "₹6,300" },
  { id: "arc_4", label: "Recommended Arc — 4 Sessions", note: "See · Understand · Release · Realign", price: "₹8,400" },
];

export const waLink = (message = "Hello Rajdeep, I would like to book a T.A.L.K. session.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
